export default "__VITE_ASSET__19a74c17__"